import aliaCurve from "~/foundation/Assets/svg/graphics/alia-curve.svg";
import { type ChakraProps } from "~/foundation/Chakra";
import type { ChatMessage } from "./ChatBotDrawer";

export const getMessageStyle = (status: ChatMessage["status"]): ChakraProps => {
	switch (status) {
		case "in":
			return {
				bg: "white",
				color: "black",
				position: "relative",
				_after: {
					content: '""',
					position: "absolute",
					top: "1.6em",
					left: "-5px",
					background: `url("${aliaCurve}")`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "contain",
					w: "22px",
					h: "39px",
				}
			};
		case "out":
			return { bg: "primary.aramcoBlue", color: "white" };
		case "error":
			return { bg: "secondary.red100", color: "white" };
		default:
			return { bg: "primary.aramcoGrey", color: "white" };
	}
}